
      import Close from './close.vue'
      import type { App, Plugin } from 'vue'

      export const ClosePlugin: Plugin = {
        install(app: App) {
          app.component('Close', Close)
        },
      }
      export { Close }
      